import { SET_ORDER_LOCKED_NUMBER } from '../actions/actionTypes';

const initialState: string = '';

export const orderLockedReducer = (state: string = initialState, action: any) => {

  switch (action.type) {
      
    case SET_ORDER_LOCKED_NUMBER:
      return action.data 
    default:
      return state;
  }
};